import ajaxRequest from '@/utils/request';

/**
*   Возвращает действия ``save{{name}}`` и ``delete{{name}}``.
*
*   Эти действия вызывают сервисы по адресу ``url`` и
*   получив ответ вызывают соответсвующие миграции.
**/

function crudActions({name, urlPart}) {
    const [saveName, deleteName] = [`save${name}`, `delete${name}`];
    urlPart = urlPart.slice(-1) === '/' ? urlPart.slice(0, -1) : urlPart;

    return {
        [saveName](context, item) {
            return new Promise((resolve, reject) => {
                ajaxRequest({
                    url: `${urlPart}/save/`,
                    method: 'POST',
                    params: item,
                    success({created, data}) {
                        context.commit(saveName, {created, data});
                        resolve({created, data});
                    },
                    failure: reject
                });
            });
        },
        [deleteName](context, item) {
            return new Promise((resolve, reject) => {
                ajaxRequest({
                    url: `${urlPart}/delete/`,
                    method: 'POST',
                    params: item,
                    success(response) {
                        context.commit(deleteName, {resolve, variable: item});
                    },
                    failure: reject
                });
            });
        }
    };
}

/**
*   Преобразует строку или массив строк ``orderBy`` в массив вида:
*   [{field: 'fieldName', dir: 'asc'}, ...]
**/

const parseOrderBy = (orderBy) => {
    let res = [{field: 'name', dir: 'asc'}];
    if (orderBy) {
        res = typeof orderBy === 'string' ? [orderBy] : orderBy;
        res = res.map(name => {
            let item = {field: name, dir: 'asc'};
            if (name[0] === '-') {
                item.field = name.slice(1);
                item.dir = 'desc';
            }
            return item;
        });
    }
    return res;
};

/**
*   Проверка должен ли стоять ``itemA`` перед ``itemB`` в соответсвии
*   с сортировкой ``orderBy``, которая представляет собой:
*   [{field: 'fieldName', dir: 'desc'}, ...]
**/

let checkOrdering = (itemA, itemB, orderBy) => {
    let res = true;
    for (let i of orderBy) {
        if ((i.dir === 'asc' && itemA[i.field] > itemB[i.field]) ||
                (i.dir === 'desc' && itemA[i.field] < itemB[i.field])) {
            res = true;
            break;
        } else if ((i.dir === 'asc' && itemA[i.field] < itemB[i.field]) ||
                (i.dir === 'desc' && itemA[i.field] > itemB[i.field])) {
            res = false;
            break;
        }
    }
    return res;
};

/**
*   Возвращает две мутации ``save{{obj.name}}`` и ``delete{{obj.name}}``.
*
*   Мутация ``save{{name}}`` вставляет или заменяет элемент в
*   массив state[obj.arrayName] в соответсвии с переданной сортировкой
*   obj.orderBy.
*
*   Мутация ``delete{{name}}`` удаляет элемент из массива state[obj.arrayName].
*
*   На вход передаем:
*   :param: obj – Object:
*       :param: idField (default='id'),
*       :param: name – String, вторая часть названия мутаций,
*       :param: editedMutation – String, название мутации, изменяющей закэшенный
*           в localStorage изменяемый объект (например, добавляет id записи
*           после её сохранения)
*       :param: arrayName – String, название массива, элементом которого должен
*           быть изменяемый объект
*       :param: pushTo – String, название route, куда редиректнуть после
*           сохранения/удаления.
**/

function crudMutations({name, arrayName, editedMutation = false,
                        orderBy = 'name', idField = 'id', pushTo = false}) {
    orderBy = parseOrderBy(orderBy);

    return {
        [`save${name}`](state, {created, data}) {
            let variable = state[arrayName];
            if (!created) {
                let old = variable.findIndex(item => item[idField] === data[idField]);
                variable.splice(old, 1);
            }
            let index = variable.findIndex(item => checkOrdering(item, data, orderBy));
            //     item.promocode > data.promocode
            // })
            variable.splice(index, 0, data);

            if (editedMutation) { this.commit(editedMutation, data); }

            if (pushTo) { router.push({name: pushTo}); }
        },
        [`delete${name}`](state, {resolve, variable}) {
            let old = state[arrayName].findIndex(item => item[idField] === variable[idField]);
            state[arrayName].splice(old, 1);

            if (editedMutation) { this.commit(editedMutation, {...variable, [idField]: null}); }

            if (pushTo) { router.push({name: pushTo}); }

            resolve && resolve();
        }
    };
}

export {
    crudActions,
    crudMutations
};



// WEBPACK FOOTER //
// ./src/utils/crud.js